// extracted by mini-css-extract-plugin
module.exports = {"cta":"LargeCTA-module--cta--2Iu-j","title":"LargeCTA-module--title--1iGW1","buttons":"LargeCTA-module--buttons--7ntNF"};